import React, { useState } from "react"
import Box from "@material-ui/core/Box"
import Checkbox from "components/Forms/Checkbox"

/** Styles */
import styles from "./styles"

interface Props {
  handleUpdate: Function
  data: any
}

const Announcement: React.FC<Props> = ({ handleUpdate, data }) => {
  const { category, section } = styles()
  const [title] = useState("facilities")

  return (
    <Box display="flex" alignItems="center" className={section}>
      <Box flex="3" className={category}>
        {title}
      </Box>
      <Box flex="1">
        {/* View */}
        <Checkbox
          label={null}
          value={Boolean(data?.facility_view)}
          onChange={() =>
            handleUpdate("facility_view", Boolean(!data?.facility_view))}
        />
      </Box>
      <Box flex="1">
        {/* Create */}
        <Checkbox
          label={null}
          value={Boolean(data?.facility_create)}
          onChange={() =>
            handleUpdate("facility_create", Boolean(!data?.facility_create))}
        />
      </Box>
      <Box flex="1">
        {/* Update */}
        <Checkbox
          label={null}
          value={Boolean(data?.facility_edit)}
          onChange={() =>
            handleUpdate("facility_edit", Boolean(!data?.facility_edit))}
        />
      </Box>
      <Box flex="1">
        {/* Delete */}
        <Checkbox
          label={null}
          value={Boolean(data?.facility_remove)}
          onChange={() =>
            handleUpdate("facility_remove", Boolean(!data?.facility_remove))}
        />
      </Box>
    </Box>
  )
}
export default Announcement
